/* eslint-disable @next/next/no-img-element */
//styles
import {
  LogosSection,
  CarouselWrapper,
  Label,
  LogosSlider,
  LogosList,
  Logo,
} from './Logos.styles';

export const logos_list = [
  { img: '/images/logos/carousel/dhl.webp', alt: 'DHL' },
  {
    img: '/images/logos/carousel/backyard-products.webp',
    alt: 'Backyard Products',
  },
  { img: '/images/logos/carousel/home-depot.webp', alt: 'The Home Depot' },
  { img: '/images/logos/carousel/red-gold.webp', alt: 'Red Gold' },
  { img: '/images/logos/carousel/cabot.webp', alt: 'Cabot' },
  {
    img: '/images/logos/carousel/athletic-brewing.webp',
    alt: 'Athletic Brewing Co',
  },
  { img: '/images/logos/carousel/volvo.webp', alt: 'Volvo' },
  { img: '/images/logos/carousel/cascades.webp', alt: 'Cascades' },
  { img: '/images/logos/carousel/unilever.webp', alt: 'Unilever' },
  {
    img: '/images/logos/carousel/cardinal-health.webp',
    alt: 'Cardinal Health',
  },
  {
    img: '/images/logos/carousel/scotts-miracle-gro.webp',
    alt: 'Scotts Miracle-Gro',
  },
  {
    img: '/images/logos/carousel/olympic-steel.webp',
    alt: 'Olympic Steel',
  },
  { img: '/images/logos/carousel/staples.webp', alt: 'Staples' },
  {
    img: '/images/logos/carousel/steele-solutions.webp',
    alt: 'Steele Solutions Inc.',
  },
  {
    img: '/images/logos/carousel/general-electric.webp',
    alt: 'General Electric',
  },
  { img: '/images/logos/carousel/saputo.webp', alt: 'Saputo' },
  { img: '/images/logos/carousel/pepsi.webp', alt: 'Pepsi' },
  {
    img: '/images/logos/carousel/thermo-fisher-scientific.webp',
    alt: 'Thermo Fisher Scientific',
  },
  {
    img: '/images/logos/carousel/sherwin-williams.webp',
    alt: 'Sherwin-Williams',
  },
  { img: '/images/logos/carousel/cargill.webp', alt: 'Cargill' },
  { img: '/images/logos/carousel/land-o-lakes.webp', alt: "Land O'Lakes" },
  { img: '/images/logos/carousel/loves.webp', alt: "Love's" },
  { img: '/images/logos/carousel/coca-cola.webp', alt: 'Coca-Cola' },
  { img: '/images/logos/carousel/thyssenkrupp.webp', alt: 'thyssenkrupp' },
];

function LogoMark({ item, lazy }) {
  return (
    <Logo>
      <img src={item.img} alt={item.alt} loading={lazy ? 'lazy' : undefined} />
    </Logo>
  );
}

export function Logos({ logos, label = true }) {
  const sliderspeed = logos.length * 4;

  return (
    <LogosSection>
      {label && <Label>Trusted by the shippers who move the world</Label>}
      <CarouselWrapper>
        <LogosSlider className="logoslider">
          <LogosList className="logoslider-list" items={sliderspeed}>
            {logos.map((item, key) => (
              <LogoMark key={key + '-a' + item.alt.trim()} item={item} />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-b' + item.alt.trim()} item={item} lazy />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-c' + item.alt.trim()} item={item} lazy />
            ))}
          </LogosList>
        </LogosSlider>
      </CarouselWrapper>
    </LogosSection>
  );
}
